import Plausible from 'plausible-tracker';
import { config } from '@/config/environment';

const plausible = Plausible({
  domain: config.analytics.domain || 'localhost',
  trackLocalhost: config.app.isDevelopment,
});

export const analytics = {
  // Track page views
  trackPageview: (url?: string) => {
    if (!config.analytics.enabled) return;
    plausible.trackPageview({ url });
  },

  // Track custom events
  trackEvent: (eventName: string, props?: Record<string, string | number | boolean>) => {
    if (!config.analytics.enabled) return;
    plausible.trackEvent(eventName, { props });
  },

  // Specific event trackers
  trackMCQAttempt: (mcqId: string, correct: boolean, difficulty: number, topic?: string) => {
    analytics.trackEvent('MCQ Attempt', {
      mcqId,
      correct,
      difficulty,
      ...(topic && { topic }),
    });
  },

  trackExamStart: (examType: string, questionCount: number) => {
    analytics.trackEvent('Exam Start', {
      examType,
      questionCount,
    });
  },

  trackExamComplete: (examType: string, score: number, durationSeconds: number) => {
    analytics.trackEvent('Exam Complete', {
      examType,
      score,
      duration: durationSeconds,
    });
  },

  trackSubscription: (plan: string, price: number) => {
    analytics.trackEvent('Subscription', {
      plan,
      price,
    });
  },

  trackBookmark: (contentType: string, contentId: string) => {
    analytics.trackEvent('Bookmark', {
      contentType,
      contentId,
    });
  },

  trackNoteCreated: (topicId: string, length: number) => {
    analytics.trackEvent('Note Created', {
      topicId,
      length,
    });
  },

  trackSignup: () => {
    analytics.trackEvent('Signup');
  },

  trackLogin: () => {
    analytics.trackEvent('Login');
  },
};
